__turbopack_context__.v({
  "CTA": "x4p7KW_CTA",
  "content": "x4p7KW_content",
  "in-grid": "x4p7KW_in-grid",
  "left": "x4p7KW_left",
  "right": "x4p7KW_right",
  "row": "x4p7KW_row",
  "text": "x4p7KW_text",
});
